// Opzioni condivise per l'Area Ingressi (funnel ammissioni)
export const COME_CONOSCIUTO = [
  { value: "telefono", label: "Telefono / contatto diretto" },
  { value: "email", label: "Email" },
  { value: "network_pay", label: "Network Pay" },
  { value: "sito", label: "Sito internet" },
  { value: "passaparola", label: "Passaparola" },
  { value: "medico", label: "Medico" },
  { value: "ospedale", label: "Ospedale" },
  { value: "assistente_sociale", label: "Assistente sociale" },
  { value: "altro", label: "Altro" },
];
export const comeConosciutoLabel = (v, altro) => {
  const f = COME_CONOSCIUTO.find((x) => x.value === v);
  if (v === "altro" && altro) return `Altro — ${altro}`;
  return f ? f.label : (v || "—");
};

export const VISITA_ESITI = [
  { value: "interessato", label: "Interessato", color: "#16a34a" },
  { value: "molto_interessato", label: "Molto interessato", color: "#15803d" },
  { value: "deve_decidere", label: "Deve decidere", color: "#ca8a04" },
  { value: "da_ricontattare", label: "Da ricontattare", color: "#d97706" },
  { value: "interessato_no_posto", label: "Interessato ma non c'è posto", color: "#0891b2" },
  { value: "lista_attesa", label: "Da inserire in lista d'attesa", color: "#7c3aed" },
  { value: "ingresso_confermato", label: "Ingresso confermato", color: "#059669" },
  { value: "non_interessato", label: "Non interessato", color: "#64748b" },
  { value: "non_idoneo", label: "Non idoneo alla struttura", color: "#b91c1c" },
  { value: "visita_annullata", label: "Visita annullata", color: "#94a3b8" },
  { value: "non_presentato", label: "Non presentato", color: "#dc2626" },
];
export const esitoLabel = (v) => (VISITA_ESITI.find((x) => x.value === v) || {}).label || v || "—";
export const esitoColor = (v) => (VISITA_ESITI.find((x) => x.value === v) || {}).color || "#64748b";

export const STATO_LEAD = {
  nuovo: { label: "Nuovo contatto", color: "#2563eb", bg: "#dbeafe" },
  visita_programmata: { label: "Visita programmata", color: "#7c3aed", bg: "#ede9fe" },
  visita_effettuata: { label: "Visita effettuata", color: "#16a34a", bg: "#dcfce7" },
  lista_attesa: { label: "In lista d'attesa", color: "#c026d3", bg: "#fae8ff" },
  ingresso_programmato: { label: "Ingresso programmato", color: "#0d9488", bg: "#ccfbf1" },
  ospite: { label: "Diventato ospite", color: "#059669", bg: "#d1fae5" },
};
export const statoLead = (s) => STATO_LEAD[s] || STATO_LEAD.nuovo;

export const PRIORITA = [
  { value: "alta", label: "Alta", color: "#dc2626" },
  { value: "media", label: "Media", color: "#d97706" },
  { value: "bassa", label: "Bassa", color: "#16a34a" },
];
export const prioritaLabel = (v) => (PRIORITA.find((x) => x.value === v) || {}).label || "Media";
export const prioritaColor = (v) => (PRIORITA.find((x) => x.value === v) || {}).color || "#d97706";

export const LISTA_STATI = [
  { value: "in_attesa", label: "In attesa", color: "#2563eb" },
  { value: "da_ricontattare", label: "Da ricontattare", color: "#d97706" },
  { value: "ancora_interessato", label: "Ancora interessato", color: "#16a34a" },
  { value: "ingresso_proposto", label: "Ingresso proposto", color: "#7c3aed" },
  { value: "ingresso_accettato", label: "Ingresso accettato", color: "#059669" },
  { value: "non_piu_interessato", label: "Non più interessato", color: "#64748b" },
];
export const listaStatoLabel = (v) => (LISTA_STATI.find((x) => x.value === v) || {}).label || v || "In attesa";
export const listaStatoColor = (v) => (LISTA_STATI.find((x) => x.value === v) || {}).color || "#2563eb";
